import { useNavigate } from "react-router-dom";
import { FaArrowLeft } from "react-icons/fa";
import "../styles/BusSchedule.scss";
import CommonButton from "../components/common/CommonButton";
import DropDownV4 from "../components/common/DropDown";
import { Box } from "@mui/material";
import { useAtomValue, useSetAtom } from "jotai";
import { tripAtom } from "../components/JotaiStates/commonStateAtoms";
import { BusesActiveAll, BusScheduleInsertUpdateCrew, BusSchListAll } from "../helper/apiUrls";
import { useEffect, useState } from "react";
import { alertAtom, globalLoaderAtom } from "../jotaiState/globalStateAtoms";
import useLogin from "../components/common/useLogin";
import { apiGet, apiPost, buildQueryString } from "../helper/utils";
import dayjs from "dayjs";

const BusSchedule = () => {
  const navigate = useNavigate();
  const trip = useAtomValue(tripAtom);
  const setLoader = useSetAtom(globalLoaderAtom);
  const setAlert = useSetAtom(alertAtom);
  const { login } = useLogin();
  const [filterVal, setFilterVal] = useState({
    busNumberList: [],
    driverList: [],
    conductorList: [],
    pickupManList: [],
    busNumberList: [],
    selDriver: [],
    selDriver2: [],
    selConductor: [],
    selPickupMan: [],
    selBusNo: [],
    selExpDep: trip?.ChartDate.substring(trip?.ChartDate.indexOf(" ") + 1)

  });
  useEffect(() => {
    getDropdownListOpt()
  }, [login.UserID])
  const getDropdownListOpt = () => {
    setLoader(true);
    const chartDate = trip?.ChartDate;
    const formattedDate = dayjs(chartDate).format("YYYY-MM-DD");
    const payload1 = {
      intUserID: login.UserID,
      intDriverConductorID: 0,
      intCompanyID: trip?.CompanyId,
      intPickupManID: 0,
      intBusID: 0,
      intIsDriver: -1,
      intStateID: 0,
      intCityID: 0,
      intIsActive: 1,
      intTripID: trip.TripID,
      dtJourneyDate: formattedDate,
      intRouteID: 0,
    };

    const payload2 = {
      intUserID: login.UserID,
      intCompanyID: trip?.CompanyId,
      intBusID: 0,
      intCompanyChartID: trip?.companychartid,
      intProprietorID: 0,
      isActive: 1,
    };
    Promise.all([
      apiGet(BusSchListAll, payload1),
      apiGet(BusesActiveAll, payload2),
    ])
      .then(([res1, res2]) => {
        if (!res1.status || !res2.status) {
          throw new Error(`${res1?.ErrorMessage || ""}\n${res2?.ErrorMessage || ""}`);
        }
        const parsedData = JSON.parse(res1.Data);
        const parsedData2 = (JSON.parse(res2.Data) || []).map(bus => ({
          ...bus,
          BusMasterNumber: bus.BusMasterNumber || bus.BusNumber
        }));
        const prevData = parsedData?.BusScheduleListAll?.[0];
        const matchedBus = parsedData2?.filter(bus => bus.BusID === prevData?.BusID1);
        const driverIdToUse = prevData?.DriverID && prevData?.DriverID !== 0 ? prevData.DriverID : login?.DriverID;
        const matchedDriver = parsedData?.DriverList?.filter(driver => driver.DriverConductorID === driverIdToUse);
        const matchedDriver2 = parsedData?.DriverList?.filter(driver => driver.DriverConductorID === prevData?.DriverID2);
        const matchedConductor = parsedData?.ConductorList?.filter(driver => driver.DriverConductorID === prevData?.ConductorID);
        const matchedPickupMan = parsedData?.PickUpList?.filter(driver => driver.PickupManID === prevData?.PickupManID);

        setFilterVal(prev => ({
          ...prev,
          driverList: parsedData?.DriverList || [],
          conductorList: parsedData?.ConductorList || [],
          pickupManList: parsedData?.PickUpList || [],
          busNumberList: parsedData2 || [],
          selBusNo: matchedBus || [],
          selDriver: matchedDriver || [],
          selDriver2: matchedDriver2 || [],
          selConductor: matchedConductor || [],
          selPickupMan: matchedPickupMan || []
        }));

      })
      .catch(err => {
        setAlert({ show: true, msg: err.message, nextId: "" });
      })
      .finally(() => {
        setLoader(false);
      });
  };
  const handleBusSchedule = () => {
    if (filterVal?.selBusNo?.length === 0) {
      setAlert({ show: true, msg: 'Select Bus Number!', nextId: "" });
    } else if (filterVal?.selConductor?.length === 0) {
      setAlert({ show: true, msg: 'Select Conductor!', nextId: "" });
    } else if (filterVal?.selPickupMan?.length === 0) {
      setAlert({ show: true, msg: 'Select PickupMan!', nextId: "" });
    } else {
      let dateOnly = trip?.ChartDate.split(" ")[0];
      setLoader(true);
      const payload = {
        intUserID: login.UserID,
        intCompanyID: trip.CompanyId,
        intTripID: trip?.TripID,
        dtJourneyDate: dayjs(trip?.JourneyDate).format("YYYY-MM-DD"),
        intBusID: filterVal?.selBusNo[0]?.BusID,
        intDriverID: filterVal?.selDriver[0]?.DriverConductorID,
        intConductorID: filterVal?.selConductor[0]?.DriverConductorID,
        intPickupManID: filterVal?.selPickupMan[0]?.PickupManID,
        dtExpectedDepartureTime: filterVal?.selExpDep,
        intDriverID2: filterVal?.selDriver2?.length === 1 ? filterVal?.selDriver2[0]?.DriverConductorID : 0,
        fromDate: dateOnly,
        toDate: dateOnly,
        isBusInfosms: false,//
        ISBusInfoSmsWithDriver: false,//
        intMode: 0,//2,//
        selectiveDate: dateOnly,
        iswaybillcreate: false,//
        multiptrip: 0,//
        strudid: 0,//
        intBusInfoSmsType: 0,//
      };
      apiPost(BusScheduleInsertUpdateCrew + "?" + buildQueryString(payload))
        .then((res) => {
          if (!res.IsSuccess) {
            throw new Error(res.ErrorMessage);
          }
          setAlert({ show: true, msg: 'Bus Schedule Successfully!', nextId: "" });
          navigate(-1);
        })
        .catch((err) => {
          setAlert({ show: true, msg: err.message, nextId: "" });
        })
        .finally(() => {
          setLoader(false);
        });
    }
  }
  return (
    <div className="bus-schedule-container">
      <div className="trip-details-header">
        <FaArrowLeft className="back-icon" onClick={() => navigate(-1)} />
        <div>
          <div className="route-text">{trip.RouteName}</div>
        </div>
      </div>
      {/* Form */}
      <div className="schedule-form">
        <Box sx={{ flex: 1 }}>
          <DropDownV4
            label="Bus Number"
            option={filterVal?.busNumberList || []}
            primaryKey="BusID"
            labelKey="BusMasterNumber"
            preSelectedValues={filterVal?.selBusNo || []}
            onSelect={(val) => {
              setFilterVal((prev) => ({ ...prev, selBusNo: val }))
            }}
            multiSelect={false}
          />
        </Box>
        <Box sx={{ flex: 1 }}>
          <DropDownV4
            label="Driver"
            option={filterVal?.driverList || []}
            primaryKey="DriverConductorID"
            labelKey="DriverConductorName"
            preSelectedValues={filterVal?.selDriver || []}
            onSelect={(val) => {
            }}
            multiSelect={false}
            disabled
          />
        </Box>
        <Box sx={{ flex: 1 }}>
          <DropDownV4
            label="Conductor"
            option={filterVal?.conductorList || []}
            primaryKey="DriverConductorID"
            labelKey="DriverConductorName"
            preSelectedValues={filterVal?.selConductor || []}
            onSelect={(val) => {
              setFilterVal((prev) => ({ ...prev, selConductor: val }))
            }}
            multiSelect={false}
          />
        </Box>
        <Box sx={{ flex: 1 }}>
          <DropDownV4
            label="Driver2"
            option={filterVal?.driverList || []}
            primaryKey="DriverConductorID"
            labelKey="DriverConductorName"
            preSelectedValues={filterVal?.selDriver2 || []}
            onSelect={(val) => {
              setFilterVal((prev) => ({ ...prev, selDriver2: val }))
            }}
            multiSelect={false}
          />
        </Box>
        <Box sx={{ flex: 1 }}>
          <DropDownV4
            label="PickupMan"
            option={filterVal?.pickupManList || []}
            primaryKey="PickupManID"
            labelKey="PickupManNameWithNumber"
            preSelectedValues={filterVal?.selPickupMan || []}
            onSelect={(val) => {
              setFilterVal((prev) => ({ ...prev, selPickupMan: val }))
            }}
            multiSelect={false}
          />
        </Box>
        <DropDownV4
          label="Expected Departure"
          option={[]}
          primaryKey="id"
          labelKey="name"
          preSelectedValues={[{ id: filterVal?.selExpDep, name: filterVal?.selExpDep }] || []}
          onSelect={(val) => { }}
          multiSelect={false}
          disabled
        />
        <CommonButton type="primary" onClick={handleBusSchedule}>
          Schedule Bus
        </CommonButton>
      </div>
    </div>
  );
};

export default BusSchedule;
